module.exports = __webpack_public_path__ + "img/chest_med.aeeb9bfe.webp";